var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-checkbox-group',{attrs:{"name":_vm.dictCode,"disabled":_vm.disabled,"value":_vm.selectedValue},on:{"change":_vm.handleChange}},_vm._l((_vm.dictItems),function(dictItem){return _c('a-checkbox',{key:dictItem.id,attrs:{"value":dictItem.value,"disabled":dictItem.disabled}},[_vm._v(" "+_vm._s(dictItem.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }